import { CookieConsent } from '@commons/CookieConsent/CookieConsent';
import { PrivacyOverlay } from '@commons/PrivacyOverlay/PrivacyOverlay';
import { isBackendUserLoggedIn } from '@commons/_utils';

// init cookie consent
let cookieConsentData = document.querySelector('script#cookie-consent-data');
if (cookieConsentData) {
    const cookieConsentTarget = document.querySelector('body');
    cookieConsentData = JSON.parse(cookieConsentData.innerHTML) || null;

    if(!await isBackendUserLoggedIn() && cookieConsentData !== null) {
        new CookieConsent(
            cookieConsentTarget,
            cookieConsentData
        );
    }
}

// init privacy overlay
let removeOverlayForTypes = [];

const handleOverlayVisibilityForConsentState = () => {
    const privacyOverlays = document.querySelectorAll('.privacy-overlay-background');
    const consent = CookieConsent.getConsent();
    if (consent?.functional) {
        removeOverlayForTypes = ['youtube', 'vimeo', 'maps'];
    }
    privacyOverlays.forEach((element) => {
        new PrivacyOverlay(element);
        if (removeOverlayForTypes.length) {
            element.dispatchEvent(new CustomEvent('privacyoverlay:removeForType', {
                detail: {
                    types: removeOverlayForTypes
                }
            }));
        }
    });
}

handleOverlayVisibilityForConsentState();

document.addEventListener('cookieConsentUpdated', () => {
    handleOverlayVisibilityForConsentState();
});


// Content that is loaded using AJAX, onepager 1 f.e., needs to be initialized separately
document.querySelector('body').addEventListener('privacyOverlay:initOnElement', (event) => {
    if (event.detail.overlayContainer) {
        const privacyOverlay = event.detail.overlayContainer.querySelector('.privacy-overlay-background');
        new PrivacyOverlay(privacyOverlay);
        if (removeOverlayForTypes.length) {
            privacyOverlay.dispatchEvent(new CustomEvent('privacyoverlay:removeForType', {
                detail: {
                    types: removeOverlayForTypes
                }
            }));
        }
    }
});
